import localStorageUtil from '@/common/utils/localStorageUtil';
import { getUserById, updateUserById } from '@/service/userService';
import API from '@aws-amplify/api';
import Constant from '../constant/Constant';

/**
 * updateUserWorkspacePanel
 * @param {*} ticketId
 * @returns
 */
export const updateUserWorkspacePanel = async (ticketId, isRemovePanel = true) => {
    let userDetail = await getUserById(API, localStorageUtil.getUserDetailId());
    const projectSelected = localStorageUtil.getSelectedProjectId();
    if (typeof userDetail === 'undefined' || projectSelected === null) {
        return;
    }
    let userWorkspace = JSON.parse(userDetail.workSpace);
    userWorkspace = userWorkspace === null ? {} : userWorkspace;
    const currentWorkspace = userWorkspace[projectSelected] || [];
    if (currentWorkspace.length) {
        userWorkspace[projectSelected] = currentWorkspace.map(element => {
            let tabList;
            if (isRemovePanel) {
                tabList = element?.tabList.filter(tab => tab?.ticketId !== ticketId);
            } else {
                tabList = element?.tabList.map(tab => {
                    if (tab.ticketId === ticketId) {
                        tab.isTicketDeleted = true;
                    }
                    return tab;
                });
            }
            return { ...element, tabList };
        });
    }
    userDetail.workSpace = JSON.stringify(userWorkspace);
    let userDetailForUpdate = {
        id: userDetail.id,
        workSpace: userDetail.workSpace
    };
    await updateUserById(API, userDetailForUpdate);
};



export const updateUserWorkLastForm = async (dataUpdate, setUserDetail, userDetailAtom) => {
    let userDetail = await getUserById(API, localStorageUtil.getUserDetailId());
    const projectSelected = localStorageUtil.getSelectedProjectId();
    if (typeof userDetail === 'undefined' || projectSelected === null) {
        return;
    }
    let workLastForm = userDetail?.workLastForm ? JSON.parse(userDetail?.workLastForm) : {};
    workLastForm = workLastForm === null ? {} : workLastForm;
    const currentWorkspace = workLastForm[projectSelected] || {};
    
    let { typeLastTicket, formId, method, projectTargetId, corpTargetId } = dataUpdate;

    if (!currentWorkspace[typeLastTicket]) {
        currentWorkspace[typeLastTicket] = {};
    }
    currentWorkspace[typeLastTicket].formId = formId;

    switch (typeLastTicket) {
        case Constant.TYPE_LAST_FORM.LAST_FORM_QA:
            currentWorkspace[typeLastTicket].projectTargetId = projectTargetId;
            currentWorkspace[typeLastTicket].corpTargetId = corpTargetId;
            break;
            
        case Constant.TYPE_LAST_FORM.LAST_FORM_NOTICE:
            currentWorkspace[typeLastTicket].method = method;
            break;
            
        case Constant.TYPE_LAST_FORM.LAST_FORM_DELEGATE:
        case Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA:
        case Constant.TYPE_LAST_FORM.LAST_FORM_INVITED:
        case Constant.TYPE_LAST_FORM.LAST_FORM_TASK:
        case Constant.TYPE_LAST_FORM.LAST_FORM_KNOWLEDGE:
        default:
            break;
    }

    workLastForm[projectSelected] = currentWorkspace;

    userDetail.workLastForm = JSON.stringify(workLastForm);
    let userDetailAtomClone = {...userDetailAtom, workLastForm}
    if (setUserDetail) {
        setUserDetail(userDetailAtomClone);
    }
    let userDetailForUpdate = {
        id: userDetail.id,
        workLastForm: userDetail.workLastForm
    };
    await updateUserById(API, userDetailForUpdate);
};